import { onPageIn, onMount, onDestroy } from '@/modules/_'

export default function (element: HTMLElement, dataset: DOMStringMap) {
  interface ArticleElement extends HTMLElement {
    dataset: DOMStringMap & {
      type?: string
    }
  }

  interface FilterButton extends HTMLElement {
    dataset: DOMStringMap & {
      filter?: string
    }
  }

  const items: ArticleElement[] = Array.from(
    document.querySelectorAll<ArticleElement>('[data-article-wrap]')
  )

  const loadMoreBtn: HTMLElement | null = document.getElementById('loadMoreBtn')
  const filterBtns: NodeListOf<FilterButton> =
    document.querySelectorAll<FilterButton>('.work_filter')

  let visibleCount: number = 12
  let currentFilter: string =
    new URLSearchParams(window.location.search).get('filter') || 'all'
  console.log('current filter', currentFilter)

  function updateActiveFilterUI(): void {
    filterBtns.forEach((btn: FilterButton): void => {
      const filter: string | undefined = btn.dataset.filter
      if (filter === currentFilter || (!filter && currentFilter === 'all')) {
        btn.classList.add('active-filter')
      } else {
        btn.classList.remove('active-filter')
      }
    })
  }

  function renderItems(): void {
    let filteredItems: ArticleElement[] = items

    // if (currentFilter !== 'all') {
    //   filteredItems = items.filter((item: ArticleElement): boolean => {
    //     return item.dataset.type === currentFilter
    //   })
    // }

    // Hide all items
    items.forEach((item: ArticleElement): void => {
      item.style.display = 'none'
    })

    // Show only the correct ones up to visibleCount
    filteredItems
      .slice(0, visibleCount)
      .forEach((item: ArticleElement): void => {
        item.style.display = 'flex'
      })

    // Hide load more button if no more items
    if (loadMoreBtn) {
      if (filteredItems.length <= visibleCount) {
        loadMoreBtn.style.display = 'none'
      } else {
        loadMoreBtn.style.display = 'flex'
      }
    }

    // updateActiveFilterUI()
  }

  // Handle filter clicks
  filterBtns.forEach((btn: FilterButton): void => {
    btn.addEventListener('click', (): void => {
      currentFilter = btn.dataset.filter || 'all'
      visibleCount = 12

      // Update URL query
      const url: URL = new URL(window.location.href)
      url.searchParams.set('filter', currentFilter)
      window.history.pushState({}, '', url.toString())

      renderItems()
    })
  })

  // Handle load more
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', (): void => {
      visibleCount += 12
      renderItems()
    })
  }

  // Initial render

  onMount(() => {
    renderItems()
  })

  onDestroy(() => {})
}
